import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgStyle } from "@angular/common";

type ILoaderMinHeightValues = number | 'full' | string;

@Component({
  selector: 'app-loader',
  templateUrl: 'loader.component.html',
  styleUrl: 'loader.component.scss',
  standalone: true,
  imports: [NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  loading = input<boolean>(true);
  minHeight = input<ILoaderMinHeightValues>(400);
  minHeightPx = computed(() => this.minHeight() !== 'full' ? `${ this.minHeight() }px` : '100vh');
}
